import { Col, Container, Row } from "react-bootstrap";
import { BzModal, BzModalFooter, BzModalHeader, BzModalBody, BzButton } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { handleModal } from "../../redux/actions/modals";

const ConfirmationBoxModal = ({ header, bodyMsg, handleConfirmed }) => {
    const modals = useSelector(state => state?.modals?.modals);
    const dispatch = useDispatch()
    const onHide = () => {
        dispatch(handleModal([{"CONFIRMATION_MODAL": false}]));
    }
    return (
        <BzModal size='sm' centered show={modals['CONFIRMATION_MODAL']} onHide={onHide}>
            <BzModalHeader className='modaltabs-header' closeButton>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-medium font-size4 color-text'>{header}</div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col className='d-flex justify-content-start'>
                            <div className='font-regular font-size4 color-text'>{bodyMsg}</div>
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
            <BzModalFooter>
                <Container fluid className='p-0 m-0'>
                    <Row className='g-0 justify-content-end'>
                        <Col md={10} className='d-flex align-items-center'>
                            <BzButton className='btn btn-md btn-block btn-outline me-3' onClick={onHide}>No</BzButton>
                            <BzButton className='btn btn-md btn-block btn-primary' onClick={handleConfirmed}>Yes</BzButton>                            
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>
    )
}

export default ConfirmationBoxModal;